angular.module('admin.campaigns').controller('CampaignDetailsCtrl',
    function ($stateParams, CampaignsResource) {


        this.loadDetails = function(){
            CampaignsResource.getDetails({
                id: $stateParams.id
            }, (data)=> {
                this.campaign = data.data.campaign;
                this.subscriptions = data.data.subscriptions || [];
            });
        }
        this.loadDetails();

    }).config(($stateProvider) => {
        $stateProvider.state('admin.campaignDetails', {
            url: 'campaigns/{id}',
            controller: 'CampaignDetailsCtrl',
            controllerAs: 'ctrl',
            templateUrl: 'views/campaigns/details.html'
        });
    });